import React from "react";
import SatisfactionIcon from "../../assets/icons/satisfied.svg";
import UserIcon from "../../assets/icons/user-profile.svg";
import GraphIcon from "../../assets/icons/graph.svg";

const services = [
  {
    title: "Satisfaction Guarantee",
    image: SatisfactionIcon,
    description:
      "Your peace of mind matters. We’re here to make sure every moment feels safe, supported, and cared for.",
  },
  {
    title: "Personal Care",
    image: UserIcon,
    description:
      "Our experienced team don’t just care.  You can trust them to treat your loved ones like family.",
  },
  {
    title: "Empowering Lives",
    image: GraphIcon,
    description:
      "We empower individuals to live with confidence, purpose, and the freedom to be themselves.",
  },
];

const FeatureCards = () => {
  return (
    <div className="relative z-20 max-w-6xl mx-auto px-4 lg:px-20 xl:px-0 mt-5 mb-[50px">
      <div className="bg-green text-white rounded-xl p-6 sm:p-10 md:p-16 shadow-lg grid grid-cols-1 xl:grid-cols-3 gap-6 text-center font-poppins">
        {services.map((service, index) => (
          <div key={index} className="flex flex-col items-center mx-2 sm:mx-3">
            <img
              src={service.image}
              alt={service.title}
              className="mx-auto w-[50px] h-[50px] sm:w-[70px] sm:h-[70px]"
            />
            <h3 className="font-semibold text-base sm:text-lg md:text-2xl mt-4 sm:mt-5">
              {service.title}
            </h3>
            <p className="text-xs sm:text-sm md:text-xl mt-3 sm:mt-4 text-[var(--gray-text-color)]">
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureCards;
